<template>
  <div v-if="persons.length" class="selected-persons">
    <q-avatar
      v-for="(person, i) in visiblePersons"
      :key="person.id"
      size="32px"
      color="grey-3"
      text-color="grey-6"
      class="selected-person cursor-pointer"
      :style="{ zIndex: persons.length - i }"
      @click.native="$emit('deselect', person.id)"
    >
      <q-img
        v-if="person.primaryFace && person.primaryFace.imageUrl"
        :src="person.primaryFace.imageUrl"
        :ratio="1"
        fit="cover"
      />
      <q-icon v-else name="fa fa-user" size="xs" />
      <q-tooltip :delay="300">{{ person.label || 'Unnamed' }}</q-tooltip>
    </q-avatar>
    <q-avatar
      v-if="overflowCount > 0"
      size="32px"
      color="primary"
      text-color="white"
      class="selected-person text-caption"
    >
      +{{ overflowCount }}
    </q-avatar>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const DEFAULT_MAX_VISIBLE = 8;

export default defineComponent({
  emits: ['deselect'],
  props: {
    persons: {
      type: Array,
      required: true,
    },
    maxVisible: {
      type: Number,
      default: DEFAULT_MAX_VISIBLE,
    },
  },
  computed: {
    visiblePersons(): any[] {
      return [...this.persons].reverse().slice(0, this.maxVisible);
    },
    overflowCount(): number {
      return Math.max(0, this.persons.length - this.maxVisible);
    },
  },
});
</script>

<style scoped>
.selected-persons {
  display: flex;
  align-items: center;
  padding-left: 4px;
}

.selected-person {
  margin-left: -14px;
  border: 2px solid white;
  transition: transform 0.15s;
}

.selected-person:first-child {
  margin-left: 0;
}

.selected-person:hover {
  transform: scale(1.3);
  z-index: 100 !important;
}
</style>
